import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/HomeCampaign.module.css';
import { Link } from 'react-router-dom';


function HomeCampaign(props) {
  const { activeCampaign } = props;

  const { name, mainImage, mainMobileImage, checkoutUrl, backgroundColor } = activeCampaign || {};

  return (
    <main className={styles.homePageCampaign}>
      <Link
        className={styles.fullWidthDesktop}
        to={checkoutUrl}
        style={backgroundColor ? { backgroundColor } : undefined}
      >
        <img
          alt={name} src={mainImage}
        />
      </Link>
      <Link className={styles.fullWidthMobile} to={checkoutUrl}>
        <img
          alt={name} src={mainMobileImage}
        />
      </Link>
    </main>
  );
}

HomeCampaign.propTypes = { activeCampaign: PropTypes.object };

HomeCampaign.defaultProps = { activeCampaign: undefined };

export default HomeCampaign;
